import {
  IComposableAnalyticsGlobalFilters,
  IRecruiterTeamNameAutoCompleteOption,
} from 'wisestep-api';
import { ITeam } from 'wisestep-base';

export const getTeamIds = (formState: IComposableAnalyticsGlobalFilters): string[] => {
  if (typeof formState?.teamIds?.[0] == 'object') {
    return (formState.teamIds as unknown as ITeam[]).map((team) => team.id as string);
  }
  if (typeof formState?.teamIds?.[0] == 'string') return formState.teamIds;
  return [];
};

export const getTeamNames = (formState: IComposableAnalyticsGlobalFilters): string[] => {
  if (typeof formState?.teamIds?.[0] == 'object') {
    return (formState.teamIds as unknown as ITeam[]).map((team) => team.name as string);
  }
  if (typeof formState?.teamNames?.[0] == 'string') {
    return formState.teamNames;
  }
  return [];
};

export const getTeamIdsAndNames = (formState: IComposableAnalyticsGlobalFilters) => {
  const teamNames = getTeamNames(formState);
  return getTeamIds(formState).map(
    (teamId, index) =>
      ({ id: teamId, name: teamNames[index] } as IRecruiterTeamNameAutoCompleteOption)
  );
};
